module.exports = __webpack_public_path__ + "static/media/add-button.f1ae3625.png";